import * as z from 'zod'
import {BasePayloadSchema} from './base-payload'

/**
 * Payload schema for manually-curated index pages.
 * Used for index pages where content is managed directly in Contentful.
 */
export const IndexPayloadSchema = z.lazy(() =>
  BasePayloadSchema.unwrap().extend({
    additionalProps: z
      .object({
        totalPages: z.number(),
        filters: z.array(
          z.object({
            value: z.string(),
            label: z.string(),
            checkboxes: z.array(
              z.object({
                label: z.string(),
                value: z.string().optional(),
                isChecked: z.boolean().optional(),
              }),
            ),
          }),
        ),
        sortOptions: z
          .array(
            z.object({
              label: z.string(),
              value: z.string(),
            }),
          )
          .optional(),
        currentSort: z.string().optional(),
        showSpotlightCard: z.boolean().optional(),
      })
      .optional(),
  }),
)

export type IndexPayload = z.infer<typeof IndexPayloadSchema>

export function toIndexPayload(payload: unknown): IndexPayload {
  return IndexPayloadSchema.parse(payload)
}
